<template>
  <div style="min-width:1000px;">
    <div>
      <div style="height:70px;">
        <span class="kzt span_font">
          控制台
        </span></br>
        <span class="kzt_span span_font">
          了解您的所有产品及使用情况
        </span>
      </div>
      <el-row :gutter="20">
        <el-col :span="24"  style="padding:0;">
            <el-col :span="8">
              <div class="grid-content bg-purple icon_div" >
                <img  src="../img/ZS.png" class="x_icon" /></br>
                <span class="span_size">产品总数</span></br>
                <span class="div_span zs">{{proZS}}</span>
              </div>
            </el-col>
            <el-col :span="8" >
              <div class="grid-content bg-purple icon_div" >
                <img  src="../img/XZ.png" class="x_icon" /></br>
                <span class="span_size">企业产品数</span></br>
                <span class="div_span xz">{{proQY}}</span>
              </div>
            </el-col>
            <!--bug 154 【狄诺尼云】【用户端】用户端应不显示禁用产品及过期产品 -->
            <!-- <el-col :span="6" >
              <div class="grid-content bg-purple icon_div" >
                <img  src="../img/GQ.png" class="x_icon" /></br>
                <span class="span_size">已过期产品</span></br>
                <span class="div_span ygq">{{proGQ}}</span>
              </div>
            </el-col> -->
            <el-col :span="8" >
              <div class="grid-content bg-purple icon_div" >
                <img  src="../img/JGQ.png" class="x_icon" /></br>
                <span class="span_size">即将过期</span></br>
                <span class="div_span jgq">{{proJGQ}}</span>
              </div>
            </el-col>
        </el-col>

        <!-- 积分统计 -->
        <el-col :span="12" style="padding-top:10px;"  v-loading="creditLoading">
          <div class="grid-content bg-purple icon_div3">
            <div style='height:65px;'>
              <span class="cptj_span px16" >积分统计</span>
              <div style="position:relative;float:right;right:10px;top:18px;">
                <el-select v-model="staTime" class="checkName" @change="changeTime('getUserMonthPointBrokenLine')">
                  <el-option v-for="item in times"  :label="item.text" :key="item.value" :value="item.value"> 
                  </el-option>
                </el-select>
              </div>
            </div>
            <div id="echartZXT" style="height:360px;top: 25px;"></div>
          </div>
        </el-col><!-- 积分统计End -->

        <el-col :span="12" style="padding-top:10px;">
          <div class="grid-content bg-purple icon_div3">
            <div style='height:65px;'>
              <span class="cptj_span" style="font-size:28px;">{{realtime}}</span>
              <span class="cptj_span px16" style="left:40px;">{{tqqk}}</span>
            </div>
            <div style='height:55px;'>
              <span class="cptj_span" style="font-size:14px;">总计登陆：</span>
              <span class="cptj_span" style="left:40px;font-size:18px;color:#F66B3D;font-weight:bold;">{{countNum}} 次</span>
            </div>
            <div style='height:30px;' v-show="lastLogin_time">
              <span style="font-size:14px;color:#F66B3D;position:relative;left:35px;">您上次登陆时间和位置：{{lastLogin_time}} , {{lastLogin_location}}</span>
            </div>
            <div style='height:30px;'>
              <span style="font-size:14px;color:#999;position:relative;left:35px;">历史记录（最近10次）</span>
            </div>
            <div style='height:25px;' v-for="item in infos">
              <span style="font-size:14px;color:#333;position:absolute;left:35px;font-weight:bold;">{{item.date}}</span>
              <span style="font-size:12px;color:#666;position:absolute;left:135px;padding-top:3px">{{item.times}}</span>
              <span style="font-size:12px;color:#666;position:absolute;left:235px;padding-top:3px;">{{item.ip}}</span>
              <span style="font-size:12px;color:#666;position:absolute;left:395px;">{{item.location}}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    
    <div style="padding-top:10px;">
      <el-row :gutter="20">
        <el-col :span="24"  style="padding:0px;">
          <el-col :span="12" >
            <div class="grid-content bg-purple icon_div2" >
                <div style='height:65px;'>
                  <span class="cptj_span px16" >产品统计</span>
                </div>
                <div class="div_div"></div>
                <!-- <div class="cptj_div" v-if="proCPlist"> -->
                <div class="cptj_div" >
                  <div v-for="product in products" style="padding:10px 50px;">
                    <img  :src="product.logo" class="cptj_img"/>
                    <span :title="product.name" class="cptj_name">{{product.name}}</span>
                    <span class="cptj_num" ><B>{{product.num}}</B></span>
                    <div class="cptj_bottom"></div>
                  </div>
                </div>
                <!-- <div v-else class="cptj_div" style="text-align:center;position:relative;line-height:15;" >
                  无数据。。。
                </div> -->
            </div>
          </el-col>

          <!-- 模块使用情况 -->
          <el-col :span="12" v-loading="moduleLoading">
            <div class="grid-content bg-purple icon_div2">
              <div style='height:65px;'>
                <span class="cptj_span px16" >模块使用情况</span>
                <div style="position:relative;float:right;right:10px;top:18px;">
                  <el-select v-model="moduleTime" class="checkName" @change="changeTime('getCompanyUserMonthModulePointPie')">
                    <el-option v-for="item in times"  :label="item.text" :key="item.value" :value="item.value"> 
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div id="echartBT" style=" height:340px"></div>
              
              <!-- <div v-else style="text-align:center;position:relative;line-height:18;" >
                无数据。。。
              </div> -->
            </div>
          </el-col>
          <!-- 模块使用情况End -->
        </el-col>
      </el-row>
    </div>


    
    <!-- <div class="ftBox">
      <div class="ft">
        <p>CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. <a href="https://beian.miit.gov.cn/" style="color: #666;" >苏ICP备18062906</a></p>
      </div>
    </div> -->
  </div>
</template>
<!-- <script src="https://pv.sohu.com/cityjson?ie=utf-8"></script> -->
<script>
import { API__code,API_Man,API_Stat} from '../../api/index.js'
import { debuglog } from 'util';
var echarts = require('echarts');
export default {
  
  data(){
    return {
      // loading
      creditLoading: false,  // 积分统计
      moduleLoading: false,  // 模块使用情况

      ip:returnCitySN["cip"],
      tqqk:'',
      lastLogin_time:'',
      lastLogin_location:'',
      weather:'',
      realtime_tq:'',
      realtime_wd:'',
      realtime_fl:'',
      realtime:'',
      city:"",
      countNum:0,
      infos:[
        // {date:'10月16日',time:'10:21',ip:'192.168.100.230',adress:'江苏省南京市'},
        // {date:'',time:'10:21',ip:'192.168.100.230',adress:'江苏省南京市'},
        // {date:'',time:'10:21',ip:'192.168.100.230',adress:'江苏省南京市'},
        // {date:'10月19日',time:'10:21',ip:'192.168.100.230',adress:'江苏省南京市'},
        // {date:'',time:'10:21',ip:'192.168.100.230',adress:'江苏省南京市'},
        // {date:'',time:'10:21',ip:'192.168.100.230',adress:'江苏省南京市'},
        // {date:'10月22日',time:'10:21',ip:'192.168.100.230',adress:'江苏省南京市'},
        // {date:'10月23日',time:'10:21',ip:'192.168.100.230',adress:'江苏省南京市'},
        // {date:'10月24日',time:'10:21',ip:'192.168.100.230',adress:'江苏省南京市'},
        // {date:'10月25日',time:'10:21',ip:'192.168.100.230',adress:'江苏省南京市'},
      ],
      staTime:'1',      // 积分统计  一个月 1 三个月 3 六个月 6 十二个月 12
      moduleTime: '1',  // 模块使用情况
      times:[
        {value:'1',text:'最近一个月'},
        {value:'3',text:'最近三个月'},
        {value:'6',text:'最近六个月'},
        {value:'12',text:'最近一年'},
        // {value:'0',text:'全部'},
      ],
      companyuseid:'',
      token:'',
      checkCode:'',
      id:'',
      proQY:0,
      proZS:0,
      proGQ:0,
      proJGQ:0,

      products:[
        // {logo:"",name:'1',num:'12'},
        // {logo:"",name:'2',num:'12'},
        // {logo:"",name:'3',num:'12'},
        // {logo:"",name:'4',num:'12'},
        // {logo:"",name:'4',num:'12'},
        // {logo:"",name:'4',num:'12'},
      ],
      proCPlist:false,
      proBTList:false,
    }
  },
  methods:{
    // 积分统计 && 模块使用情况
    changeTime(method){
      this[method]();
    },
    
    getUserGroupProductSum:function(){
      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,
        userid:this.id,
      }
      API_Man.getUserGroupProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.length > 0){
            this.proCPlist = true;
            _this.products = res.data.data;
          }else{
            this.proCPlist = false;
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    getUserProductSum:function(){
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        userid:this.id,
      }
      API_Man.getUserProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.proZS = res.data.data[0].num;
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    getcompanySetUserProductSum:function(){
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyuseid,
        userid:this.id,
      }
      API_Man.getcompanySetUserProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.proQY = res.data.data[0].num;
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },

    getUserDueProductSum:function(){
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        userid:this.id,
      }
      API_Man.getUserDueProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.proGQ = res.data.data[0].num;
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    getUserDueInMonthProductSum:function(){
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        userid:this.id,
      }
      API_Man.getUserDueProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.proJGQ = res.data.data[0].num;
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    //个人30天饼图
    getCompanyUserMonthModulePointPie:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        userid:this.id,
        count: this.moduleTime
      }
      this.moduleLoading = true;
      API_Stat.getCompanyUserMonthModulePointPie(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          var modulenames = [];
          var modul = [];
          for(var i=0;i<res.data.data.length;i++){
            modulenames.push(res.data.data[i].modulename);
            var json = {value:res.data.data[i].sumpoint, name:res.data.data[i].modulename}
            modul.push(json);
          }
          // modul = [
          //   {value:10,name:'张三'},
          //   {value:10,name:'李四'},
          //   {value:10,name:'王五'},
          //   {value:10,name:'钱牛'},
          //   {value:10,name:'李四1'},
          //   {value:10,name:'王五1'},
          // ];
          // modulenames = ['张三','李四','王五','钱牛','李四1','王五1'];
          this.echart2(modulenames,modul);
          this.moduleLoading = false;
        }else{
          this.moduleLoading = false;
          _this.$message.error(res.data.message);
          if(res.data.code == 403){
            _this.$router.push({path: 'login'});
          }
        }
      });
    },
    //个人30天折线图
    getUserMonthPointBrokenLine:function(id){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        userid:this.id,
        count: this.staTime
      }
      let _this = this;
      this.creditLoading = true;
      API_Stat.getUserMonthPointBrokenLine(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.dateTime = [];
          this.dataNum = [];
          for(var i=0;i<res.data.data.length;i++){
            if(res.data.data[i].date && res.data.data[i].date.length>6){
              // _this.dateTime.push(res.data.data[i].date.substring(5).replace(/-/g,"月") + '日');
            }
             _this.dateTime.push(res.data.data[i].date)
            if(res.data.data[i].sumpoint || res.data.data[i].sumpoint == 0){
              _this.dataNum.push(res.data.data[i].sumpoint);
            }
          }
          _this.echart1(_this.dateTime,_this.dataNum);
          this.creditLoading = false;
        }else{
          this.creditLoading = false;
          _this.$message.error(res.data.message);
          if(res.data.code == 403){
            _this.$router.push({path: 'login'});
          }
        }
      });
    },
    //读取cookie
    getCookie: function() {
      this.id = sessionStorage.getItem('dnnypt_id');
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); 
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); 
          if (arr2[0] == 'dnnypt_token') {
              this.token = arr2[1];
          } else if (arr2[0] == 'dnnypt_checkCode') {
              this.checkCode = arr2[1];
          }
        }
      }
    },
    echart1 :function(dataTime,dataNumber){
      var myChart = echarts.init(document.getElementById('echartZXT'));
      myChart.setOption({
        tooltip: {
            trigger: 'axis'
        },
        grid: {
            top:'3%',
            left: '3%',
            right: '4%',
            bottom: '5%',
            containLabel: true
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],

        xAxis: {
            type: 'category',
            boundaryGap: false,
            data:dataTime,
        },
        yAxis: {
            type: 'value',
            axisLine: {
                show: true,
                lineStyle: {
                    color: "rgba(219,225,255,1)",
                    width: 0,
                    type: "solid"
                }
            },
            axisLabel: {//y轴文字的配置
                textStyle: {
                     color: "#333333",
                     margin: 15
                },
               // formatter: '{value} %'//y轴的每一个刻度值后面加上‘%’号
            },
        },
        
        series: [
            {
                name:'积分',
                type:'line',
                stack: '总量',
                data:dataNumber,
            },
        ]
      });
    },
    echart2:function(data1,data2){
      var myChart = echarts.init(document.getElementById('echartBT'));
      myChart.setOption({
        tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
            bottom: 10,
            left: 'center',
            data:data1,
        },
        series : [{
          name: '模块名称',
          type: 'pie',
          radius : '55%',
          center: ['50%', '45%'],
          data:data2,
          itemStyle: {
            emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
            normal:{
              color:function(params) {
              //自定义颜色
                var colorList = [          
                    '#CDDC39', '#E6EE9C', '#AEEA00', '#FFEA00', '#FFA000','#FFCC80',
                    '#F48FB1', '#FF5722', '#D50000', '#7B1FA2', '#7C4DFF','#B388FF',
                    '#3949AB', '#536DFE', '#8C9EFF', '#64B5F6', '#2196F3','#607D8B',
                    '#4CAF50', '#00E5FF','#64FFDA',
                ];
                return colorList[params.dataIndex]
              }
            }
          }
        }]
      });
    },

    getLoginInfor:function(){
      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        userid:this.id,
        clientip:this.ip,
      }
      API_Man.getLoginInfor(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          var arr = [];
          if(res.data.data.weather && res.data.data.weather != '天气信息获取失败！'){
            _this.weather = JSON.parse(res.data.data.weather);
            _this.city = _this.weather.value[0].provinceName + _this.weather.value[0].city;
            _this.realtime_tq = _this.weather.value[0].realtime.weather;
            _this.realtime_wd = _this.weather.value[0].realtime.sendibleTemp;
            _this.realtime_fl = _this.weather.value[0].realtime.wD + _this.weather.value[0].realtime.wS;
            _this.tqqk = _this.realtime_tq +'，气温' + _this.realtime_wd + '℃，'+ _this.realtime_fl;
            _this.realtime = _this.weather.value[0].realtime.time.substring(5,10);
            _this.realtime = _this.realtime.replace(/-/g,"月") + '日';
          } 
          
          for(var i=0;i<res.data.data.loginInfor.length;i++){
            if(res.data.data.loginInfor[i].time){
              res.data.data.loginInfor[i].date =  res.data.data.loginInfor[i].time.substring(5,10);
              res.data.data.loginInfor[i].date = res.data.data.loginInfor[i].date.replace(/-/g,"月") + '日';
              res.data.data.loginInfor[i].times =  res.data.data.loginInfor[i].time.substring(11,16);
            }
            if(arr.length > 0){
              for(var k=0;k<arr.length;k++){
                if(res.data.data.loginInfor[i].date == arr[k]){
                  res.data.data.loginInfor[i].date = '';
                }
              }
            }
            arr.push(res.data.data.loginInfor[i].date);
          }
          if(res.data.data.loginInfor.length>0){
            _this.lastLogin_time = res.data.data.loginInfor[0].time;
            _this.lastLogin_location = res.data.data.loginInfor[0].location;
          }
          _this.infos = res.data.data.loginInfor;
          _this.countNum = res.data.data.loginCount;
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
  },
  mounted() {
    //个人产品总数
    this.getUserProductSum();
    // 获取企业分配给个人产品总数
    this.getcompanySetUserProductSum();
    //获取个人过期产品总数
    this.getUserDueProductSum();
    // 获取个人即将过期（30天）产品总数
    this.getUserDueInMonthProductSum();
    //分类企业产品
    this.getUserGroupProductSum();
    //个人30天饼图
    this.getCompanyUserMonthModulePointPie();
    //个人30天折线图
    this.getUserMonthPointBrokenLine();
    //获取天气、登录日志等内容
    this.getLoginInfor();
  },
  created(){
    this.companyuseid = sessionStorage.getItem('companyuseid');
    this.getCookie();
  }
}
</script>

<style scoped>
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.bg-purple {
  border:1px solid #d3dce6;
}
.icon_div{
  text-align:center;
  position: relative;
  height: 164px;
  background: #fff;
  margin-bottom: 10px;
}
.icon_div2{
  position: relative;
  height:400px;
  background: #fff;
  margin-bottom: 10px;
}
.icon_div3{
  position: relative;
  height:470px;
  background: #fff;
  margin-bottom: 10px;
}
.span_size{
  font-size: 16px;
  position: relative;
  top: 10px;
}
.div_span{
  font-size: 28px;
  font-weight: Bold;
  position: relative;
  top:25px;
}
.zs{
  color:#577CCC;
}
.ygq{
  color:#FCA63F;
}
.xz{
  color:#55BF3C;
}
.jgq{
  color:#38C8CD;
}
.x_icon{
  position: relative;
  text-align: center;
  left: 0;
  height:54px;
  width:54px;
  padding-top: 15px;
}
.cptj_span{
  position:relative;
  left:35px;
  top:20px;
  color:#333333;
}
.px16{
  font-size:16px;
}
.div_div{
  width:80%;
  position:relative;
  left:10%;
  height:1px;
  background:#EFF0F2;
}
.cptj_div{
  height:270px;
  overflow-x:auto;
}
.cptj_img{
  height:36px;
  width:36px;
}
.cptj_name{
  position: relative;
  left: 20px;
  top: -11px;
  font-size:18px;
  color:#333333;
}
.cptj_num{
  position: relative;
  right: 20px;
  top:8px;
  float:right;
  font-size:20px;
  color:#333333;
}
.cptj_bottom{
  position:relative;
  height:1px;
  background:#EFF0F2;
  top:8px;
}
.span_font{
  font-family: "思源黑体 CN Bold Bold";
}
.kzt{
  position: relative;
  top: -15px;
  left: 9px;
  font-size:20px;
  font-weight: bold;
  color:#666;
}
.kzt_span{
  position: relative;
  top: 0px;
  left: 9px;
  font-size:14px;
  font-weight: Normal;
  color:#666;
}
.checkName{
  position: absolute;
  width:115px;
  right: 10px;
  top: -3px;
}
</style>



// WEBPACK FOOTER //
// Management.vue?4f78559c